import React, { useContext, useEffect, useState } from 'react'
import { Button, Col, Container, Form, Row, Spinner, Modal } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { apiCreateAnnouncement, apiDeleteAnnouncement, apiGetAnnouncementsByCommunityId, apiUpdateAnnouncement } from '../api/api';
import { CommunityContext } from './CommunityContext';
import { ReactComponent as EditIcon } from '../img/edit.svg'
import { ReactComponent as DeleteIcon } from '../img/delete.svg'
import { ReactComponent as CloseIcon } from '../img/close-window.svg'
import { Alert } from '@mui/material';

const CommunityAnnouncement = () => {
  let { id } = useParams()
  const navigate = useNavigate()
  const communityId = id
  const { userData } = useContext(CommunityContext)
  const [announcements, setAnnouncements] = useState(null);
  const [isUpdated, setIsUpdated] = useState(null);
  const [deleteData, setDeleteData] = useState({id:'',content:''})
  const [inputContent, setInputContent] = useState('')
  const [InputUpdateComment, setInputUpdateComment] = useState('')
  const [showWarning, setshowWarning] = useState(false)
  const [isUpdating, setIsUpdating] = useState(false)
  const [show, setShow] = useState(false)
  const [alertText, setAlertText] = useState('')
  const [alertVariant, setAlertVariant] = useState('info')
  const handleClose = () => setShow(false)
  const handleShow = (deleteData) => {
    setDeleteData(deleteData)
    setShow(true)
  }
  const createdAtFormat = (createdAt) => {
      return createdAt.substring(11,19) + ", " + createdAt.substring(0, 10)
  }

  const handleWarning = () => {
    setshowWarning(true)
    setTimeout(() => setshowWarning(false), 3000)
  }

  const handleCommentChange = (event) => {
      setInputContent(event.target.value)
  }

  const handleSubmit = async (event) => {
      event.preventDefault()
      let data = {
          content: inputContent
      }
      apiCreateAnnouncement(communityId, data).then((res) => {
        fetchAnnouncements()
        setInputContent('')
      }).catch(error => {
          console.log(error.response)
          setAlertVariant("error")
          setAlertText("Something went wrong")
          handleWarning()
      })
  }

  const handleDelete = async (id) => {
      apiDeleteAnnouncement(id).then(() => {
          handleClose()
          fetchAnnouncements()
          setAlertVariant("success")
          setAlertText("Announcement deleted")
          handleWarning()
      }).catch(error => {
          console.log(error.response)
          setAlertVariant("error")
          setAlertText("Something went wrong")
          handleWarning()
      })
  }


  const handleUpdateCommentChange = (event) => {
      setInputUpdateComment(event.target.value)
  }

  const handleUpdate = async (event) => {
      event.preventDefault()
      setIsUpdating(true)
      let data = {
          content: InputUpdateComment
      }
      apiUpdateAnnouncement(isUpdated.id, data).then((res) => {
          fetchAnnouncements()
          setIsUpdated(null) 
      }).catch(error => {
          console.log(error.response)
          setAlertVariant("error")
          setAlertText("Something went wrong")
          handleWarning()
      })
  }

  const fetchAnnouncements = async () => {
    apiGetAnnouncementsByCommunityId(communityId).then((res) => {
      setAnnouncements(res.data)
      setIsUpdating(false)
    }).catch(error => {
        console.log(error.response)
        alert("Something went wrong while loading announcements!")
        navigate('/')
    })
  }

  useEffect(() => {
    fetchAnnouncements()
  }, [])

  return (
    <>
      <Container className='readPost' style={{paddingTop:0}}>
        {showWarning &&
        <Alert style={{marginBottom:"24px"}} severity={alertVariant} onClose={() => setshowWarning(false)}>
            {alertText}
        </Alert>
        }
        { userData.isAdmin &&
            <Row>
                <div className='comment-component'>
                    <form onSubmit={handleSubmit}>
                        <Row>
							<Col className="col-create-comment">
                                <Form.Control data-testid="input-comment-bar" value={inputContent} type="text" name="name" onChange={handleCommentChange} placeholder="Add an announcement..." required></Form.Control>
                            </Col>
							<Col className="col-create-comment-button">
								<Button variant="warning" type="submit">Submit</Button>
							</Col>
                        </Row>
                    </form>
                </div>
            </Row>
          }
          {announcements && announcements.map((announcement, index) => {
              return (
                  <Row key={index}>
                      <div className='comment-component'>
                              {userData.isAdmin ?
                                <>
                                    <DeleteIcon onClick={() => { 
                                        handleShow(announcement)
                                    }}
                                        className='delete' title="delete" data-testid="delete-comment" />

                                    <EditIcon onClick={() => {
                                        setInputUpdateComment(announcement.content)
                                        setIsUpdated({ id: announcement._id })
                                    }}
                                        className='edit' title="edit" data-testid="edit-comment" />
                                  </>
                                  :
                                  null
                              }
                          <h5>Admin</h5>
                          <h6>Published at {createdAtFormat(announcement.createdAt)}</h6>
                          <p>{announcement.content}</p>
                      </div>
                      {isUpdated != null && isUpdated.id === announcement._id && (
                        <form onSubmit={handleUpdate}>
                            <Row>
                                <Col xs="9">
                                    <Form.Control data-testid="input-comment-update-bar" value={InputUpdateComment} type="text" name="name" onChange={handleUpdateCommentChange} placeholder="Update Comment..." required></Form.Control>
                                </Col>
                                <Col xs="2">
                                        { isUpdating ? 
                                        <Button data-testid="submit-update" variant="warning" type="submit" disabled> <Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true"/></Button> : 
                                        <Button data-testid="submit-update" variant="warning" type="submit">Submit</Button>
                                        }
                                </Col>
                                <Col xs="1">
                                    <div onClick={() => { setIsUpdated(null) }} target="_blank" rel="noopener noreferrer">
                                        <CloseIcon className='close' />
                                    </div>
                                </Col>
                            </Row>
                        </form>
                      )}
                  </Row>
              )
          })}

      </Container>
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
            <Modal.Title>Are you sure you want to delete this announcement?</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>{deleteData.content}</p>
        </Modal.Body>
        <Modal.Footer>
            <Button data-testid="cancel-delete-comment" variant="secondary" onClick={() => {
                setDeleteData({id:'',content:''})
                handleClose()
            }}>
                Cancel
            </Button>
            <Button data-testid="confirm-delete-comment" variant="warning" onClick={() => { handleDelete(deleteData._id) }}>
                Delete
            </Button>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default CommunityAnnouncement